import {AdminPccActivityLogsTable} from "./atoms/AdminActivityLogsTable";
import {Spinner} from "../../atoms/spinner";
import {ActivityLogHeader} from "./atoms";
import {useFetchActivitiesLog} from "./hooks";
import {Facilities} from "../../models/types/AdmissionForm";

export const AdminPccActivityLogsTableContainer = ({
  facilities,
  facilityId,
}: {
  facilityId: string;
  facilities: Facilities;
}) => {
  const facility = facilities?.find(f => f.id === facilityId);

  const {isFetching, data, fetchNextPage} = useFetchActivitiesLog(
    facilities,
    facility?.id || "",
  );

  return !facility && isFetching && !data?.pages.length ? (
    <Spinner />
  ) : (
    <AdminPccActivityLogsTable
      activityLogs={data?.pages.flat() || []}
      header={<ActivityLogHeader facilityId={facilityId} />}
      isLoading={isFetching}
      loadMoreEnabled
      tableName="activity logs"
      loadMore={fetchNextPage}
    />
  );
};
